import { useState } from 'react';

import { Accordion } from '@iwoca/orion';
import { plural } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './BankStatementsDE.module.css';
import ManualUploadDE from './ManualUploadDE';
import { useGetContext } from '../../../../../lendingApi/lendingApiQueries';
import {
  TOfferDataRequirement,
  TTrueLayerAlertStatus,
} from '../../../../../types';
import Required from '../../../DocumentRequirement/Required';
import OpenBanking from '../../../OpenBanking/OpenBanking';
import { getLinkedBankAccountDetails } from '../../../OpenBanking/trueLayer.helpers';
import TrueLayerAlertBox from '../../../OpenBanking/TrueLayerAlertBox/TrueLayerAlertBox';
import TrueLayerLinkedAccount from '../../../OpenBanking/TrueLayerLinkedAccount/TrueLayerLinkedAccount';

type TProps = {
  quantifier: number;
  status?: TOfferDataRequirement['actions'][number]['status'];
  isSubmitted: boolean;
  resolutionMethods: TOfferDataRequirement['actions'][number]['resolution_methods'];
};

const BankStatementsDE = ({
  quantifier,
  status,
  isSubmitted,
  resolutionMethods,
}: TProps) => {
  const [trueLayerAlertStatus, setTrueLayerAlertStatus] =
    useState<TTrueLayerAlertStatus>(null);

  const { context } = useGetContext();

  const { t } = useLingui();

  const title = plural(quantifier, {
    one: 'Business bank statements for the last # month',
    other: 'Business bank statements for the last # months',
  });

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        {/* id has space instead of hyphen to match other dynamic ids used for scrolling to requirements */}
        <h4
          className={clsx(styles.title, styles.titleWithSubtitle)}
          id="document-requirement-bank statement"
        >
          {title}
          {isSubmitted && (status === 'required' || status === 'error') && (
            <Required />
          )}
        </h4>
      </div>

      <OpenBanking setAlertStatus={setTrueLayerAlertStatus} />
      <Accordion
        title={t`My bank is not available to link`}
        small
        variant="secondary"
      >
        <ManualUploadDE
          title={title}
          status={status}
          isSubmitted={isSubmitted}
        />
      </Accordion>
      {trueLayerAlertStatus && (
        <TrueLayerAlertBox status={trueLayerAlertStatus} />
      )}
      <TrueLayerLinkedAccount
        linkedBankAccount={getLinkedBankAccountDetails(
          resolutionMethods,
          context,
        )}
      />
    </div>
  );
};

export default BankStatementsDE;
